{
  "en": {
    "profile": "Profile",
    "admin": "Administration",
    "layerSwitcher": "Layers",
    "getAlert": "Alerts",
    "getFeature": "Features",
    "editFeature": "Edit features",
    "editMeasure": "Measurement",
    "editNotice": "Notices",
    "editMariners": "Notes",
    "editObstruction": "Obstructions",
    "editIssue": "Issues",
    "shipPlacement": "Ship Placement",
    "passagePlan": "Planning Passage",
    "ais": "AIS",
    "notification": "Notifications",
    "ulhysses": "Ulhysses",
    "wayEditor": "Route Planning",
    "replay": "Replay",
    "dbmanager": "Database Manager",
    "fullScreen": "Full Screen",
    "overview": "Overview",
    "measure": "Measure",
    "polylineMeasure": "Polyline Measure",
    "speedVector": "Speed Vector",
    "aisAnchorLabel": "AIS Anchor Label",
    "carViz": "Car Visualization",
    "gpsCenter": "GPS Center",
    "centerPosition": "Center Position",
    "cleanAIS": "Clean AIS",
    "displayQuotations": "Display Quotations",
    "draughtTideSlider": "Draught Tide Slider",
    "wait-for-data": "No data yet",
    "etaControl": "ETA",
    "select-vessel": "Please, select a vessel",
    "attached-files": "Attached files",
    "delete-attached-file": "Delete attached file",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "attention": "Attention !",
    "message-delete": "You are about to delete the following attached file :",
    "message-delete-warning": "These action is irreversible. Are you sure you want to proceed ?"
  },
  "fr": {
    "profile": "Profile",
    "admin": "Administration",
    "layerSwitcher": "Couches",
    "getAlert": "Alertes",
    "getFeature": "Objets",
    "editFeature": "Editeur d'objet",
    "editMeasure": "Quotations",
    "editNotice": "Notices",
    "editMariners": "Notes",
    "editObstruction": "Obstructions",
    "editIssue": "Problèmes",
    "shipPlacement": "Placement de gabarit",
    "passagePlan": "Passage Plan",
    "ais": "AIS",
    "notification": "Notifications",
    "ulhysses": "Ulhysses",
    "wayEditor": "Planification de route",
    "replay": "Rejouer",
    "dbmanager": "Database Manager",
    "fullScreen": "Plein écran",
    "overview": "Vue globale",
    "measure": "Mesure",
    "polylineMeasure": "Mesure multiple",
    "speedVector": "Speed Vector",
    "aisAnchorLabel": "Labels d'ancrage AIS",
    "carViz": "Visualisation de voitures",
    "gpsCenter": "Centre GPS",
    "centerPosition": "Position centrale",
    "cleanAIS": "Clean AIS",
    "displayQuotations": "Affichage des quotations",
    "draughtTideSlider": "Curseur de marée",
    "wait-for-data": "Pas de données pour l'instant",
    "etaControl": "ETA",
    "select-vessel": "Veuillez selectionner un bateau",
    "attached-files": "Fichiers joints",
    "delete-attached-file": "Suppression d'un fichier joint",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "attention": "Attention !",
    "message-delete": "Vous êtes sur le point de supprimer le fichier join suivante :",
    "message-delete-warning": "Cette action est irreversible. Êtes-vous sur de vouloir continuer ?"
  }
}